import { requestSaga } from 'common/utils/generators';
import resources from 'common/constants/resources';
import dataProvider from 'store/dataProvider';
import { procedureActionTypes } from '../reducer';

function* createProcedure() {
  yield requestSaga({
    actionType: procedureActionTypes.create,
    request: dataProvider.createOne,
    resource: resources.procedure.index,
  });
}

export default createProcedure;
